import React from 'react'

import EventCard from './Card'
import { Event } from '../../../api/events/types'
import Loading from '../layout/Loading'
import NoResults from '../layout/NoResults'

type Props = { data: Event[] | null | undefined, isLoading: boolean, error: Error | null }
type PropsWithClearFilter = Props & {
  onClearFilter?: () => void
  totalResults?: number
}
const EventsList: React.FC<PropsWithClearFilter> = ({ data, isLoading, error, onClearFilter, totalResults = 0 }) => {
  if(isLoading) return <Loading size='fill-container' />
  if(error) return <div>{error.message}</div>
  if(!data || data.length === 0) return <NoResults onClearFilter={onClearFilter} totalResults={totalResults} />
  return (
    data.map((event) => (
      <div key={event.title} className='my-3'>
        <EventCard
          id={event.id}
          title={event.title}
          startDate={event.startDate}
          endDate={event.endDate}
          authors={event.authors}
          type={event.type}
          location={event.location}
          streamingLink={event.streamingLink}
          rsvpStatus={event.rsvpStatus}
        />
      </div>
    ))
  )
}

export default EventsList
